<template>
    <div v-if="offer">
        <h2>Offerteopdracht {{ offer['details']['json_data']['reference']}}</h2>
        <h3>Algemene info</h3>
        <Table class="border-0">
            <tr>
                <td>Dossiernr.:</td>
                <td>{{ offer['details']['json_data']['reference'] }}</td>
            </tr>
            <tr>
                <td>Type:</td>
                <td>
                    <template v-if="offer['details']['json_data']['property_type'] === 'residential'">
                        Residentieël
                    </template>
                    <template v-else>
                        Niet-residentieël
                    </template>
                </td>
            </tr>
            <tr>
                <td>Oppervlakte categorie:</td>
                <td>
                    <Select
                        name="surface_id"
                        :options="surfaceOptions"
                        :emptyOption="true"
                        :sortByLabel="false"
                        v-model="formSurface.surface_id"
                        :error="formSurface.errors.surface_id"
                    />
                </td>
            </tr>
            <tr>
                <td>Oppervlakte:</td>
                <td>{{ offer['details']['json_data']['gross_surface_area'] }}m²</td>
            </tr>
            <tr>
                <td>Klant:</td>
                <td>{{ offer['details']['json_data']['invoice_information']['name'] }}</td>
            </tr>
            <tr>
                <td class="align-top">Inspectieadres:</td>
                <td>
                    {{ offer['details']['json_data']['inspection_location_address']['street'] }} {{ offer['details']['json_data']['inspection_location_address']['number'] }} {{ offer['details']['json_data']['inspection_location_address']['box'] }}<br>
                    {{ offer['details']['json_data']['inspection_location_address']['zip_code'] }} {{ offer['details']['json_data']['inspection_location_address']['city'] }}
                </td>
            </tr>
            <template v-if="offer['details']['broker']">
                <tr>
                    <td>Makelaar:</td>
                    <td>{{ offer['details']['broker']['person'] }}</td>
                </tr>
                <tr>
                    <td>E-mail makelaar:</td>
                    <td>
                        <a :href="'mailto:' + offer['details']['broker']['mail']">
                            {{ offer['details']['broker']['mail'] }}
                        </a>
                    </td>
                </tr>
                <tr>
                    <td>Telefoon makelaar:</td>
                    <td>
                        {{ offer['details']['broker']['phone'] }}
                    </td>
                </tr>
                <tr>
                    <td>Kantoor:</td>
                    <td>{{ offer['details']['broker']['company'] }}</td>
                </tr>
            </template>
        </Table>

        <h3 class="mt-4">Facturatie info</h3>
        <Table class="border-0">
            <tr>
                <td>Type:</td>
                <td>
                    <template v-if="offer['details']['json_data']['invoice_information']['invoice_type'] === 'private'">
                        Particulier
                    </template>
                    <template v-else>
                        Zakelijk
                    </template>
                </td>
            </tr>
            <tr>
                <td>Naam:</td>
                <td>{{ offer['details']['json_data']['invoice_information']['name'] }}</td>
            </tr>
            <tr>
                <td class="align-top">Adres:</td>
                <td>
                    {{ offer['details']['json_data']['invoice_information']['street'] }} {{ offer['details']['json_data']['invoice_information']['number'] }} {{ offer['details']['json_data']['invoice_information']['box'] }}<br>
                    {{ offer['details']['json_data']['invoice_information']['zip_code'] }} {{ offer['details']['json_data']['invoice_information']['city'] }}
                </td>
            </tr>
            <tr>
                <td>Email:</td>
                <td>
                    <a :href="'mailto:' + offer['details']['json_data']['invoice_information']['email']">
                        {{ offer['details']['json_data']['invoice_information']['email'] }}
                    </a>
                </td>
            </tr>
            <tr>
                <td>Telefoon:</td>
                <td>{{ offer['details']['json_data']['invoice_information']['phone'] }}</td>
            </tr>
            <tr>
                <td>GSM:</td>
                <td>{{ offer['details']['json_data']['invoice_information']['mobile'] }}</td>
            </tr>
            <tr>
                <td>BTW-nummer:</td>
                <td>{{ offer['details']['json_data']['invoice_information']['business_vat'] }}</td>
            </tr>
        </Table>
        <h3 class="mt-4">Bijlages</h3>
        <ul v-if="attachments.length > 0">
            <template v-for="attachment in attachments" :key="attachment">
                <li v-if="attachment.lastIndexOf('/') === attachmentsPath.length">
                    <a :href="'/requests/dewaele-potential-offers/download-attachment?reference=' + reference + '&filename=' + encodeURIComponent(attachment.substring(attachment.lastIndexOf('/') + 1, attachment.length))">
                        {{ attachment.substring(attachmentsPath.length + 1, attachment.length) }}
                    </a>
                </li>
                <template v-else>
                    <template :set="attachmentsSubfolder = true"></template>
                </template>
            </template>
        </ul>
        <!--                            Bijlages in submappen -->
        <div class="mt-2 mb-4" v-if="attachmentsSubfolder">
            <h4>Bijlages in submap(pen)</h4>
            <template v-for="attachment in attachments" :key="attachment">
                <li v-if="attachment.lastIndexOf('/') > attachmentsPath.length">
                    <a :href="'/requests/dewaele-potential-offers/download-attachment?reference=' + reference + '&filename=' + encodeURIComponent(attachment.substring(attachment.lastIndexOf('/') + 1, attachment.length))
                                    + '&submap=' + encodeURIComponent(attachment.substring(attachmentsPath.length + 1, attachment.length - attachment.substring(attachment.lastIndexOf('/') + 1, attachment.length).length))">
                        {{ attachment.substring(attachmentsPath.length + 1, attachment.length) }}
                    </a>
                </li>
            </template>
        </div>
        <Button
            htmlType="a"
            linkType="normal"
            text="Download alle bijlagen"
            buttonClass="download"
            :href="'/requests/dewaele-potential-offers/download-attachments?reference=' + reference"
        />
        <div class="flex justify-end mt-6">
            <Button
                text="Webshoporder"
                buttonClass="purple"
                @click="confirmWebshopOrder"
            />
            <Modal
                :id="reference + '_existing'"
                buttonClass="alt"
                buttonText="Bestaande offerte"
                ref="modalExisting"
            >
                <div>
                    <Form @submitted="createExistingOffer">
                        <h3>Bestaande offerte</h3>
                        <Input
                            label="Offerte referentie"
                            name="offer_reference"
                            :required="true"
                            v-model="formExisting.offer_reference"
                            :error="formExisting.errors.offer_reference"
                        />
                        <Button
                            text="Bestaande offerte overschrijven"
                            type="submit"
                            :loading="formExisting.processing"
                            class="self-end"
                        />
                    </Form>
                </div>
            </Modal>
            <Modal
                :id="reference + '_new'"
                buttonClass="success"
                buttonText="Nieuwe offerte"
                ref="modalNew"
            >
                <div>
                    <Form @submitted="createNewOffer">
                        <h3>Nieuwe offerte</h3>
                        <Input
                            label="Offerte referentie"
                            name="offer_reference"
                            :required="true"
                            v-model="formNew.offer_reference"
                            :error="formNew.errors.offer_reference"
                        />
                        <Button
                            text="Offerte aanmaken"
                            type="submit"
                            :loading="formNew.processing"
                            class="self-end"
                        />
                    </Form>
                </div>
            </Modal>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'

import store from '@/store'
import {ref, watch} from "vue";
import { Inertia } from "@inertiajs/inertia"
import {useForm} from "@inertiajs/inertia-vue3";


export default {
    components: {
        AppLayout,
        PageTitle,
        Table,
        Th,
        Td,
        Button,
        Modal,
        Form,
        Input,
        Select,
    },
    props: {
        offer: {
            required: true
        },
        reference: {
            required: true
        },
        surfaces: {
            required: true
        },
        surfaceId: {
            required: true
        },
        attachments: {
            required: true
        },
        attachmentsPath: {
            required: true
        },
    },
    emits: ['closeModal'],
    setup (props, { emit }) {
        let attachmentsSubfolder = false
        let modalExisting = ref(null)
        let modalNew = ref(null)
        let surfaceOptions = {}

        const formExisting = useForm({
            external_reference: props.reference,
            offer_reference: null,
        })

        const formNew = useForm({
            external_reference: props.reference,
            offer_reference: null,
        })

        const formSurface = useForm({
            surface_id: props.surfaceId,
        })

        props.surfaces.forEach(function(surface) {
            surfaceOptions[surface.id] = new DOMParser().parseFromString(surface.size, "text/html").documentElement.textContent;
        })

        watch(
            () => props.surfaceId,
            (newValue) => {
                formSurface.surface_id = newValue
            }
        );

        function confirmWebshopOrder(event)
        {
            if (!confirm('Bent u zeker dat u een webshoporder voor deze aanvraag wil aanmaken?'))
                return

            Inertia.post('/requests/dewaele-potential-offers/create-webshop-order', {
                    'reference': props.reference,
                    'surfaceId': formSurface.surface_id,
                },
                {
                    onSuccess: () => {
                        emit('closeModal')
                    },
                    onError: (errors) => {
                        emit('closeModal')
                    }
                }
            )
        }

        function createExistingOffer()
        {
            formExisting.post('/requests/dewaele-potential-offers/existing-offer', {
                onSuccess: () => {
                    emit('closeModal')
                },
                onError: (errors) => {
                    emit('closeModal')
                }
            })
        }

        function createNewOffer()
        {
            formNew.post('/requests/dewaele-potential-offers/create-offer', {
                onSuccess: () => {
                    emit('closeModal')
                },
                onError: (errors) => {
                    emit('closeModal')
                }
            })
        }

        return {
            state: store.state,
            ...store,
            attachmentsSubfolder,
            confirmWebshopOrder,
            createExistingOffer,
            createNewOffer,
            formExisting,
            formNew,
            formSurface,
            modalExisting,
            modalNew,
            surfaceOptions,
        }
    }
}

</script>

